import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=bc12c04e&scoped=true"
import script from "./BurgerButton.vue?vue&type=script&lang=js"
export * from "./BurgerButton.vue?vue&type=script&lang=js"
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=bc12c04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc12c04e",
  null
  
)

export default component.exports